var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SurveyElementBase } from "survey-react-ui";
var CreatorModelElement = /** @class */ (function (_super) {
    __extends(CreatorModelElement, _super);
    function CreatorModelElement(props) {
        var _this = _super.call(this, props) || this;
        _this.createModel(props);
        return _this;
    }
    CreatorModelElement.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var result = _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
        if (result) {
            if (this.needUpdateModel(nextProps)) {
                this.createModel(nextProps);
            }
        }
        return result;
    };
    CreatorModelElement.prototype.createModel = function (props) { };
    CreatorModelElement.prototype.needUpdateModel = function (nextProps) {
        var names = this.getUpdatedModelProps();
        if (!Array.isArray(names))
            return true;
        for (var i = 0; i < names.length; i++) {
            var key = names[i];
            if (this.props[key] !== nextProps[key])
                return true;
        }
        return false;
    };
    CreatorModelElement.prototype.getUpdatedModelProps = function () {
        return undefined;
    };
    return CreatorModelElement;
}(SurveyElementBase));
export { CreatorModelElement };
